module.exports = __webpack_public_path__ + "static/other/gameFacePainting.effcb8d9.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameFacePainting.json
// module id = 2661
// module chunks = 0